import { DocumentNode, gql } from '@apollo/client'

export const LINK_TRUSTEE: DocumentNode = gql`
    mutation LinkTrustee($groupId: Int!, $email: Email!, $trustee: DaycareTrusteeUpdateInput) {
        linkTrustee(groupId: $groupId, email: $email, trustee: $trustee)
    }
`

export const UNLINK_TRUSTEE: DocumentNode = gql`
    mutation UnlinkTrustee($groupId: Int!, $trusteeId: Int!) {
        unlinkTrustee(groupId: $groupId, trusteeId: $trusteeId)
    }
`

export const DELETE_TRUSTEE: DocumentNode = gql`
    mutation DeleteTrustee($trusteeId: Int!) {
        deleteTrustee(trusteeId: $trusteeId)
    }
`

export const SET_MAIN_TRUSTEE: DocumentNode = gql`
    mutation SetMainTrustee($groupId: Int!, $trusteeId: Int!) {
        setMainTrustee(groupId: $groupId, trusteeId: $trusteeId)
    }
`

export const UPDATE_TRUSTEE_LINK: DocumentNode = gql`
    mutation UpdateTrusteeLink($groupId: Int!, $trusteeId: Int!, $canWrite: Boolean) {
        updateTrusteeLink(groupId: $groupId, trusteeId: $trusteeId, canWrite: $canWrite)
    }
`
